/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_PitchInputs */

const en_home_pitch = /** @type {(inputs: Home_PitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interactive demo of multi-fleet orchestration: heterogeneous robots cooperate inside the same building, share lifts and doors, and execute your tasks in real time. Sign in to explore the simulation.`)
};

const fr_home_pitch = /** @type {(inputs: Home_PitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démonstration interactive d'orchestration multi-flottes : des robots hétérogènes coopèrent dans un même bâtiment, partagent ascenseurs et portes, et exécutent vos tâches en temps réel. Connectez-vous pour explorer la simulation.`)
};

const ms_sg2_home_pitch = /** @type {(inputs: Home_PitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demonstrasi interaktif orkestrasi pelbagai armada: robot heterogen bekerjasama dalam bangunan yang sama, berkongsi lif dan pintu, dan menjalankan tugasan anda secara masa nyata. Log masuk untuk meneroka simulasi.`)
};

/**
* | output |
* | --- |
* | "Interactive demo of multi-fleet orchestration: heterogeneous robots cooperate inside the same building, share lifts and doors, and execute your tasks in real..." |
*
* @param {Home_PitchInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const home_pitch = /** @type {((inputs?: Home_PitchInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_PitchInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_pitch(inputs)
	if (locale === "fr") return fr_home_pitch(inputs)
	return ms_sg2_home_pitch(inputs)
});